<script lang="ts">
	import { type BlockComponent } from './structuredText'
	import type { TextModelTextBlocksField } from 'datocms/models'

	interface Props {
		item: TextModelTextBlocksField
		variables?: Record<string, string>
		components?: BlockComponent[]
	}

	let { item, variables = {}, components = [] }: Props = $props()

	function getComponentByType(type: string) {
		return components.find((component) => component.__typename === type)
	}
</script>

{#if getComponentByType(item.__typename)}
	{@const SvelteComponent = getComponentByType(item.__typename).component}
	<SvelteComponent {item} {variables} />
{/if}
